/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetTopBetsByAnnouncementModel,
  IGetTopBetsByAnnouncementRequest,
  IMappers,
  IGetTopBetsByAnnouncementResponse,
  IGetTopBetsByAnnouncementResponseError,
  TGetTopBetsByAnnouncementResponse,
} from './types';

const defaultConfig: TGetTopBetsByAnnouncementModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'auction',
  pathApi: '/v2/get-top-bets-by-announcement/',
  hostType: 'api',
} as TGetTopBetsByAnnouncementModel;

function createGetTopBetsByAnnouncementModel(
  parameters: IGetTopBetsByAnnouncementRequest,
): TGetTopBetsByAnnouncementModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetTopBetsByAnnouncementOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetTopBetsByAnnouncementRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetTopBetsByAnnouncement<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetTopBetsByAnnouncementOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetTopBetsByAnnouncementResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetTopBetsByAnnouncementModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetTopBetsByAnnouncementResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetTopBetsByAnnouncementResponseError);
    }
  }

  return { response, statusCode } as TGetTopBetsByAnnouncementResponse;
}

export { defaultConfig, createGetTopBetsByAnnouncementModel, fetchGetTopBetsByAnnouncement };
